import { Navigate } from 'react-router-dom';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import PendingApprovalsPage from './pages/PendingApprovalsPage';

/**
 * Kurumsal Onay Kuyrukları (corporate approval queues) — migration guide Bölüm 3.8 / 4.12 /
 * 5.3 / 6.2. Gated behind `HasKurumsal` + the current user having linked corporate employees,
 * matching this app's other Kurumsal-only modules (see demandsModule for the same pattern).
 */
const isVisible = (user: Parameters<NonNullable<ModuleDefinition['menuItems'][number]['isVisible']>>[0]) =>
  !!user?.corporateEmployees && isFeatureEnabled('HasKurumsal');

export const corporateApprovalsModule: ModuleDefinition = {
  routes: [
    { path: 'corporate/approvals', element: <Navigate to="/corporate/approvals/flight" replace /> },
    { path: 'corporate/approvals/flight', element: <PendingApprovalsPage productType="Flight" /> },
    { path: 'corporate/approvals/hotel', element: <PendingApprovalsPage productType="Hotel" /> },
    { path: 'corporate/approvals/rent-car', element: <PendingApprovalsPage productType="RentCar" /> },
    { path: 'corporate/approvals/transfer', element: <PendingApprovalsPage productType="Transfer" /> },
    { path: 'corporate/approvals/bus', element: <PendingApprovalsPage productType="Bus" /> },
  ],
  menuItems: [
    {
      label: 'Onay Listeleri',
      path: 'corporate/approvals/flight',
      icon: <FactCheckIcon />,
      group: 'Kurumsal',
      isVisible,
    },
  ],
};
